import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { UserService,User } from '../../shared';
import { environment } from '../../shared/config/app-config';


@Component({
  templateUrl: 'report.component.html',
  styleUrls: ['./style.component.css']
  
  
})

export class ReportComponent implements OnInit {
  img:any;
  painscore:any;
  diffscore:any;
  label:any;
  CurrentUser:User
  barChartData:any;
  public barChartLabels:string[];
  apiurl:any = environment.api_url;
  public data: Object;
  report:any;
  constructor(
    private route:ActivatedRoute,
    private router: Router,
    private userService: UserService
    
  ) {
    
  }


  
  imageURL:string="";
  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )

    if(this.CurrentUser.item.hostModel=="CLOUD")
    this.imageURL = environment.cloudeImageURL;
   else   
    this.imageURL = environment.vmImageURL;

    if(this.route.snapshot.url[0].path != 'assessment'){
			this.CurrentUser.operationStatus = ''
		  }
    // this.userService
    // .getreport()
    // .subscribe(
    //   data => 
    //   {
    //     this.report = data;
    //     var pain = data[0].painScore.split(',')
    //     var diffscore = data[0].difficultyScore.split(',')
    //     this. label = data[0].label.split(',')
    //     this.painscore = pain.map(n=>{
    //       return parseInt(n)
    //     })
    //     this.diffscore = diffscore.map(n=>{
    //       return parseFloat(n)
    //     })
        
    //     //////console.log(this.painscore)
    //     this.barChartData = [
    //       {
            
    //         data:this.painscore,
    //         label: 'Pain Level',
    //         fill: false,
    //         pointHitRadius: 7,
    //         pointRadius: 7,
    //         pointHoverRadius: 7},
    //       {
    //         data: this.diffscore, 
    //         label: 'Difficulty Level',
    //         fill: false,
    //         pointHitRadius: 14,
    //       pointRadius: 14,
    //       pointHoverRadius: 14}
        
    //     ]
    //     this.barChartLabels = this.label;
    //   }      
    // ); 
    
   
    
   
  }
 
  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true,
    hoverMode: 'index',
    stacked: false,
    height:'800px',      
    title:{
      display: true,
      text:'Pain & Difficulty Graph'
    },
    scales: {
      yAxes: [{
      type: "linear",
      ticks: {
          reverse: false,
          min:0,
          max:12
      },
      }]
    }

  };
  
  public barChartType:string = 'line';
  public barChartLegend:boolean = true;

 
  /* public barChartData:any[] = [
    {data: [this.painscore],
     label: 'Pain Level',
     fill: false,
     pointHitRadius: 7,
     pointRadius: 7,
     pointHoverRadius: 7},
    {data: [this.diffscore], 
    label: 'Difficulty Level',
    fill: false,
    pointHitRadius: 14,
    pointRadius: 14,
    pointHoverRadius: 14}
  
  ]; */

  public barColors: any[] = [
  	{
      backgroundColor:"#ff9f40",
      borderColor: "#ff9f40"
    },
    {
      backgroundColor:"#36a2eb",
      borderColor: "#36a2eb"
    }

  ];
}
  

   
 
  

